import { StatusChip } from "components/StatusChip";

type PaymentIssueBadgeProps = {
  isStaff?: boolean;
  hasPaymentIssue?: boolean;
};

/**
 * Renders a staff-only "Payment issue" badge when the submission has an
 * unresolved payment issue. The `isStaff` gate lives here — neither call
 * site needs to replicate the condition.
 */
export function PaymentIssueBadge({ isStaff, hasPaymentIssue }: PaymentIssueBadgeProps) {
  if (!isStaff || !hasPaymentIssue) {
    return null;
  }
  return <StatusChip color="error" label="Payment issue" />;
}
